import { CurrencyPayResponse } from '../redux/models/currencyPay';
import { paymentMethodACH } from './PaymentTypes';

const getPaymentStatus = function getPaymentStatus(
  responseData: CurrencyPayResponse[]
): string {
  const hasAnAchTransaction = responseData.some(r =>
    r.data.some(p => paymentMethodACH.some(i => i === p.payment.method))
  );

  if (hasAnAchTransaction) {
    return 'Pending';
  }

  return 'Paid';
};
export default getPaymentStatus;
